{
  "name": "academate-ui",
  "version": "1.0.0.CR5",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build --aot",
    "build:production": "ng build --base-href=/academate/ --aot",
    "build:staging": "ng build --base-href=/academate4j/ --aot --configuration staging",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.10",
    "@angular/cdk": "^21.0.5",
    "@angular/common": "^21.2.10",
    "@angular/compiler": "^21.2.10",
    "@angular/core": "^21.2.10",
    "@angular/forms": "^21.2.10",
    "@angular/material": "^21.0.5",
    "@angular/platform-browser": "^21.2.10",
    "@angular/platform-browser-dynamic": "^21.2.10",
    "@angular/router": "^21.2.10",
    "@ngrx/effects": "^21.0.1",
    "@ngrx/router-store": "^21.0.1",
    "@ngrx/store": "^21.0.1",
    "@ngrx/store-devtools": "^21.0.1",
    "cookieconsent": "^3.1.1",
    "echarts": "^6.0.0",
    "marked": "^17.0.1",
    "ngx-cookieconsent": "^8.0.0",
    "ngx-echarts": "^21.0.0",
    "ngx-extended-pdf-viewer": "^25.6.4",
    "ngx-markdown": "^21.1.0",
    "ngx-sse-client": "^21.0.0",
    "ngx-ui-tour-md-menu": "^16.0.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@angular/build": "^21.2.8",
    "@angular/cli": "^21.2.8",
    "@angular/compiler-cli": "^21.2.10",
    "@types/jasmine": "~5.1.0",
    "jasmine-core": "~5.6.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.9.3"
  }
}
